import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './Logos.css';
import PCPLogo from '../assets/PCPLogo';

const Logos = ({ smallLogos }) => (
  <div className={smallLogos ? styles.containerSmall : styles.container}>
    <PCPLogo smallLogos={smallLogos} />
  </div>
);

Logos.propTypes = {
  smallLogos: PropTypes.bool,
};

export default Logos;



// WEBPACK FOOTER //
// ./src/components/Logos.jsx